
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M765 607H150q-13 0-21.5-8.5T120 577q0-13 8.5-21.5T150 547h616l-86-86q-8-8-8-20t9-21q9-9 21-9t21 9l136 136q5 5 7 10t2 11q0 6-2 11t-7 10L723 734q-10 10-21.5 9.5T681 734q-9-9-9-21.5t8-20.5l85-85z"}})])
          )
        }
      }
    